<template>
    <section class="flex flex-column m-auto align-content-center mt-6" v-if="operacaoBoletoDisponivel">
        <div>
            <p>Pagar com BOLETO é fácil e rápido</p>
            <ul>
                <li>1- O boleto estará disponível somente <strong>72 horas úteis</strong> antes do início do evento.</li>
                <li>2- Clique no botão Gerar Boleto.</li>
                <li>3- Copie o código que aparecerá no campo.</li>
                <li>4- Pronto agora é só finalizar o pagamento e aguardar a aprovação</li>
            </ul>
        </div>
        <Button @click="gerarBoleto" class="m-auto w-full border-1 p-3 flex align-items-center justify-content-center" v-if="linhaDigitavel == null">
            <i class="pi pi-barcode mr-2" />
            Gerar Boleto
        </Button>
        <div v-if="linhaDigitavel !== null" class="codigo-boleto">
            <p>Pagamento com Boleto Bancário</p>
            <div class="input-container" @click="copiarCodigo">
                <input v-model="linhaDigitavel" type="text" readonly />
                <i class="pi pi-copy pointer-cursor" @click="mostrarAlerta" style="font-size: 1rem"></i>
            </div>
            <p v-if="error">{{ error }}</p>
            <div class="p-fluid flex align-items-center justify-content-center mb-2">
                <Tag v-if="linhaDigitavel" class="flex align-items-center justify-content-center p-2">Boleto válido até o dia {{ dataVencimentoBoleto }}</Tag>
            </div>
            <a href="#" @click.prevent="abrirBoleto" class="abrir-boleto">Abrir boleto</a>
        </div>
    </section>
    <section class="flex flex-column m-auto align-content-center mt-3" v-if="!operacaoBoletoDisponivel">
        <div class="mt-3">
            <Message severity="warn" size="large" icon="pi pi-exclamation-circle"
                >Olá, participante! O boleto não pode ser gerado, pois o prazo <strong>máximo de 72 horas úteis </strong>antes do início do evento já
                expirou</Message
            >
        </div>
    </section>
</template>

<script>
import service from './service';

export default {
    name: 'BoletoForm',
    data() {
        return {
            linhaDigitavel: null,
            produtoCheckoutId: this.$route.params.id,
        };
    },
    props: {
        operacaoBoletoDisponivel: {
            type: Boolean,
            default: false,
        },
        dataVencimentoBoleto: {
            type: String,
            default: '',
        },
    },
    methods: {
        gerarBoleto() {
            this.$store.dispatch('addRequest');
            const produtoCheckoutId = this.$route.params.id;

            if (!produtoCheckoutId) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Produto Checkout ID não encontrado na URL.',
                    life: 3000,
                });
                return;
            }

            service
                .pagamentoBoleto(produtoCheckoutId)
                .then((response) => {
                    const data = response.data;

                    if (!data) {
                        this.linhaDigitavel = null;
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Código Boleto',
                            detail: data?.errors?.[0]?.errorMessage ?? 'Erro inesperado ao gerar o boleto.',
                            life: 3000,
                        });
                        return;
                    }

                    this.linhaDigitavel = data.linhaDigitavel || null;

                    if (data.erro || data.status === 'Erro') {
                        const mensagemErro = data.erro || 'Ocorreu um erro ao gerar o boleto. Tente novamente mais tarde ou entre em contato com o suporte.';
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Gerar Boleto',
                            detail: mensagemErro,
                            life: 10000,
                        });
                    } else if (data.erro === '') {
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Obter boleto',
                            detail: 'Boleto obtido com sucesso!',
                            life: 3000,
                        });
                    }
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Código Boleto',
                        detail: error?.message ?? String(error),
                        life: 3000,
                    });
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },
        async copiarCodigo() {
            await navigator.clipboard.writeText(this.linhaDigitavel);
        },
        mostrarAlerta() {
            this.copiarCodigo();
            this.$swal({
                title: 'Código Copiado!',
                icon: 'success',
                timer: 2000,
                showConfirmButton: false,
                position: 'top-end',
                toast: true,
                customClass: {
                    confirmButton: 'custom-button',
                },
            });
        },
        abrirBoleto() {
            this.$store.dispatch('addRequest');
            const produtoCheckoutId = this.$route.params.id;
            service.ExportarPdf(produtoCheckoutId).then((response) => {
                if (response) {
                    this.$download(response, 'Boleto.pdf');
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },
};
</script>

<style scoped>
.barcode {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
}
.codigo-boleto {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
}
.input-container {
    align-items: center;
    border: 1px solid #ccc;
    padding: 5px;
    border-radius: 5px;
    background-color: #f9f9f9;
    margin-bottom: 8px;
    width: 390px;
}
.input-container input {
    border: none;
    outline: none;
    padding: 5px;
    flex: 1;
    background-color: #f9f9f9;
    width: 360px;
}
.input-container .icon-copiar {
    cursor: pointer;
    margin-left: 10px;
}
.abrir-boleto {
    color: #4caf50;
    font-weight: bold;
    text-decoration: none;
    margin-top: 10px;
}
.abrir-boleto:hover {
    text-decoration: underline;
}
.pointer-cursor {
    cursor: pointer;
}

.custom-button {
    background-color: #4caf50 !important;
    color: #000 !important;
}
</style>
